import React from 'react';
import PropTypes from 'prop-types';
import defaults from '../theme';
import { deepMerge } from '../utils/util';

function Thumbnail({ index, src, thumbnail, active, onClick, theme = {} }) {
  const url = thumbnail || src;
  const mergedTheme = deepMerge(defaults, theme);
  const { size, gutter, activeBorderColor } = mergedTheme.thumbnail;

  return (
    <div
      className={`bg-center bg-cover rounded cursor-pointer inline-block overflow-hidden shadow-[inset_0_0_0_1px_hsla(0,0%,100%,0.2)] ${
        active ? `shadow-[inset_0_0_0_2px_${activeBorderColor}]` : ''
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(index);
      }}
      style={{
        backgroundImage: `url("${url}")`,
        width: size,
        height: size,
        margin: gutter,
      }}
    />
  );
}

Thumbnail.propTypes = {
  theme: PropTypes.object,
  active: PropTypes.bool,
  index: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  src: PropTypes.string,
  thumbnail: PropTypes.string,
};

export default Thumbnail;
